{
  "title": "Transfer receipt",
  "direction": "Direction",
  "directions": {
    "BANK_TO_CASH": "Bank to cash",
    "CASH_TO_BANK": "Cash to bank"
  },
  "date": "Date",
  "time": "Time",
  "transferNumber": "Transfer number",
  "amount": "Transfer amount",
  "amountReceived": "Amount received from the customer",
  "commission": "Commission",
  "netCash": "Net cash paid",
  "netTransferred": "Amount transferred",
  "sender": "Sender",
  "receiver": "Receiver",
  "bankName": "Bank name",
  "employee": "Employee",
  "commissionMode": "Commission method",
  "commissionModes": {
    "DEDUCTED": "Deducted from the amount",
    "ADDED": "Added on top of the amount"
  }
}
